import * as React from "react"
import { clearToken, getToken, setToken } from "./token"
import { getMe, login as apiLogin } from "./api"

const AuthContext = React.createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = React.useState(null)
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    let mounted = true

    async function hydrate() {
      const token = getToken()
      if (!token) {
        if (mounted) {
          setUser(null)
          setLoading(false)
        }
        return
      }

      try {
        const me = await getMe()
        if (mounted) setUser(me)
      } catch {
        if (mounted) {
          clearToken()
          setUser(null)
        }
      } finally {
        if (mounted) setLoading(false)
      }
    }

    hydrate()
    return () => {
      mounted = false
    }
  }, [])

  async function login({ email, password, role }) {
    const data = await apiLogin({ email, password, role })
    setToken(data.token)
    setUser(data.user)
  }

  function completeAuth(data) {
    setToken(data.token)
    setUser(data.user)
  }

  function logout() {
    clearToken()
    setUser(null)
  }

  const value = React.useMemo(
    () => ({
      user,
      loading,
      login,
      completeAuth,
      logout,
    }),
    [user, loading]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const ctx = React.useContext(AuthContext)
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider")
  return ctx
}

